"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoListItem;

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDom = require("react-dom");

var _ThumbnailAssetSelector = _interopRequireDefault(require("./ThumbnailAssetSelector"));

var _utils = require("../../../../../utils");

var _colors = _interopRequireDefault(require("../../../../../styles/colors"));

require("../styles/_video-list-item.scss");

var _VideoId = _interopRequireDefault(require("./VideoId"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getRemainingTimeClass(time, status) {
  if (status === 'DRAFT') {
    return 'none';
  }

  if (!time || time < 8) {
    return 'low';
  }

  if (time < 16) {
    return 'medium';
  }

  return 'default';
}

function pushToOutputUrl(output, action, history) {
  return function () {
    if (action === 'BRIEF') {
      return void history.push("/builder/".concat(output.videoId));
    }

    return void history.rootPush("/review/".concat(output.videoId, "/").concat(output.outputId));
  };
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.stopPropagation();
    e.preventDefault();
    fn(e);
  };
}

function getOutputStatusSpecificActions(output, history) {
  if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER') {
    return [];
  }

  return [{
    action: withNoEventPropagation(pushToOutputUrl(output, 'HISTORY', history)),
    label: 'View Version History'
  }];
}

function setActionPopupRef(setRef) {
  // We don't have access to .contains on the react ref
  // eslint-disable-next-line react/no-find-dom-node
  return function (el) {
    setRef((0, _reactDom.findDOMNode)(el));
  };
}

var getDaysAndHoursToDueDate = (0, _memoizeOne.default)(function (hoursLeft) {
  var days = Math.floor(hoursLeft / 24);
  var hours = hoursLeft % 24;
  return "".concat(days ? "".concat(days, "d ") : '').concat(hours, "h");
});

var onItemClick = function onItemClick(output, history, actionPopupRef) {
  return withNoEventPropagation(function (e) {
    if (actionPopupRef && actionPopupRef.contains(e.target)) {
      return;
    }

    if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER' || output.status.name === 'COST_REVIEW' && !output.video.submittedAt) {
      return void history.push("/builder/".concat(output.videoId));
    }

    if (output.status.name === 'APPROVED') {
      return void history.push("/complete/".concat(output.videoId, "/").concat(output.outputId));
    }

    history.rootPush("/review/".concat(output.videoId, "/").concat(output.outputId));
  });
};

function VideoListItem(_ref) {
  var history = _ref.history,
      output = _ref.output,
      onDelete = _ref.onDelete,
      onShare = _ref.onShare,
      isShowArchived = _ref.isShowArchived,
      onToggleArchived = _ref.onToggleArchived,
      onDuplicate = _ref.onDuplicate,
      onViewDetails = _ref.onViewDetails;
  var video = output.video,
      status = output.status,
      latestVersion = output.latestVersion,
      versions = output.versions,
      isMaster = output.isMaster,
      readableId = output.readableId,
      onHoldDate = output.onHoldDate,
      _output$onHoldReason = output.onHoldReason,
      onHoldReason = _output$onHoldReason === void 0 ? '' : _output$onHoldReason;
  var creator = video.creator,
      videoName = video.name,
      clips = video.clips;
  var creatorName = creator ? "".concat(creator.firstName, " ").concat(creator.lastName) : '';

  var _ref2 = versions.find(function (_ref3) {
    var versionNumber = _ref3.versionNumber;
    return versionNumber === latestVersion;
  }) || {},
      dueDate = _ref2.dueDate,
      assetId = _ref2.assetId;

  var dueDateLeft = dueDate ? (0, _moment.default)(dueDate, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).diff((0, _moment.default)(), 'hours') : 0;
  var remainingTime = dueDateLeft <= 0 ? '0h' : getDaysAndHoursToDueDate(dueDateLeft);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      actionPopupRef = _useState2[0],
      setRef = _useState2[1];

  var onClick = onItemClick(output, history, actionPopupRef);
  var hasSLA = status.name !== 'DRAFT' && status.name !== 'PENDING_MASTER' && status.name !== 'APPROVED';
  return /*#__PURE__*/_react.default.createElement(_ThumbnailAssetSelector.default, {
    assetId: assetId,
    videoAssetIds: clips.map(function (_ref4) {
      var assetId = _ref4.assetId;
      return assetId;
    })
  }, function (thumbnailAsset) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
      onClick: onClick,
      customCoverImage: thumbnailAsset ? /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
        asset: thumbnailAsset,
        hideFileTypeIcon: true,
        canPlayVideo: false,
        darkMode: true
      }) : void 0,
      coverImageProps: {
        defaultImageIcon: 'video',
        defaultIconColour: 'russian',
        defaultIconSize: 50
      }
    }, hasSLA ? /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__preview__version",
      style: {
        background: _colors.default[status.name]
      }
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      darkTheme: true,
      noMargin: true,
      centered: true
    }, "v".concat(latestVersion))) : null, /*#__PURE__*/_react.default.createElement(_VideoId.default, {
      videoId: readableId
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__header__status"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__header__status__text",
      style: {
        background: _colors.default[status.name]
      }
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      label: true,
      darkTheme: true,
      noMargin: true
    }, (0, _utils.getOutputStatusLabel)(status.name))), status.name === 'ON_HOLD' ? /*#__PURE__*/_react.default.createElement(_uiKit.ErrorIcon, {
      size: 20,
      errorMessage: "Your editor is pending clarification on your brief or is waiting for additional / missing assets.",
      id: output.outputId
    }) : null), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
      ref: setActionPopupRef(setRef),
      options: [{
        action: withNoEventPropagation(onViewDetails(output)),
        label: 'View Details'
      }, {
        action: withNoEventPropagation(pushToOutputUrl(output, 'BRIEF', history)),
        label: 'View Project Brief'
      }].concat(_toConsumableArray(getOutputStatusSpecificActions(output, history)), [{
        action: withNoEventPropagation(onShare),
        label: 'Share With Others'
      }, {
        action: withNoEventPropagation(onDuplicate({
          videoId: output.videoId,
          name: videoName
        })),
        label: 'Duplicate Video'
      }, {
        separator: true
      }, {
        action: withNoEventPropagation(onToggleArchived),
        label: !isShowArchived ? 'Archive' : 'Unarchive'
      }, {
        action: withNoEventPropagation(onDelete(output)),
        label: 'Delete',
        isRed: true
      }])
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__name"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      heading4: true,
      noMargin: true
    }, (0, _getVideoOutputName.default)(output, video.name)), isMaster ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "master",
      color: "goldenTainoi",
      tooltipId: "toolId-".concat(readableId),
      tooltipLabel: "Master video",
      size: 20
    }) : null, onHoldDate ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      className: "list-item__content__details__name__on-hold",
      name: "alert",
      size: 20,
      color: "thunderBird",
      tooltipId: "toolOnHoldId-".concat(output.outputId),
      tooltipLabel: "Video on hold: ".concat(onHoldReason)
    }) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__footer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__footer__creator"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      label: true
    }, "Created By"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
      circular: true,
      height: "30px",
      width: "30px",
      placeholderText: creatorName,
      imageUrl: (0, _lodash.default)(creator, 'imageUrl'),
      placeholderTextSize: 10
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      label: true,
      noMargin: true
    }, creatorName))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-item__body__footer__time"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      label: true
    }, "Time Remaining"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      heading3: true,
      noMargin: true,
      className: "video-list-item__body__footer__time__hours--".concat(getRemainingTimeClass(dueDateLeft, status.name))
    }, hasSLA && dueDate ? remainingTime : '-')))));
  });
}